import { IonSpinner } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import {
  wsGetListaMultimediaPaciente,
  wsGetTurnosPaciente,
} from "_+_Portal/context/Actions/turnos/turnosPaciente";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  ContainerBody,
  ContainerEditarOrden,
  ContainerTop,
} from "./localStyle";

import {
  wsDeleteOrdenLaboratorio,
} from "_+_Portal/context/Actions/ordenLaboratorio/ordenLaboratorio";
import { GlobalContext } from "global/context/Provider";
import ConfirmImage from "../ConfirmImagen/ConfirmImage";
import SubirEditarOrden from "../SubirEditarOrden/SubirEditarOrden";
import { wsDeleteImagenes } from "_+_Portal/context/Actions/orden/orden";


const EditarOrden = ({ dissmiss, turno }) => {
  //#region  ----------- useContext---------------

  const { turnosPacienteDispatch, selectDropDownState,   ordenLaboratorioDispatch,} =
    useContext(PortalContext);
  const { ordenDispatch } = useContext(GlobalContext);

  const [image, setImage] = useState([]);
  const [index, setIndex] = useState(0);
  const [imageMod, setImageMod] = useState(0);
  const [loading, setLoading] = useState(true);
  //#endregion -------- useContext---------------

  //#region  ----------- funtions ---------------
  const orderImage = (isCorrect, data) => {
    setLoading(false);
    data = data.sort((a, b) => {
      if (a.idRemoto > b.idRemoto) return 1;
      if (a.idRemoto < b.idRemoto) return -1;
      else return 0;
    });
    if (isCorrect) {
      setImage(data);
    }
  };
  const familiarID = !selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? false
    : selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo;
  const success = () => {
    let nextStep = () => {
      dissmiss();
      wsGetTurnosPaciente(familiarID)(turnosPacienteDispatch);
    };
    setLoading(true);  
    
    if (!turno?.idProtocolo){
      wsDeleteImagenes(turno.idturno, nextStep)(ordenDispatch);
    }else {
      wsDeleteOrdenLaboratorio(turno.idProtocolo,"-1", nextStep )(ordenLaboratorioDispatch)
    }
  };
  const fail = () => {
    dissmiss();
  };

  //#endregion  -------- funtions ---------------

  //#region  ----------- useEffects ---------------
  useEffect(() => {
    if (turno?.idProtocolo > 0) {
      wsGetListaMultimediaPaciente(
        false,
        turno.idProtocolo,
        false,
        orderImage
      )(turnosPacienteDispatch);
      // setFlgActualiceOrden(true);
    } else {
      wsGetListaMultimediaPaciente(
        turno.idturno,
        false,
        false,
        orderImage
      )(turnosPacienteDispatch);
      // setFlgActualiceOrden(true);
    }
  }, []);

  //#endregion  -------- useEffects ---------------

  return (
    <ContainerEditarOrden>
      <ContainerTop className={"bgcG-latex30"}>
        <span>Editar orden</span>
        <span className="cruz" onClick={dissmiss}>
          X
        </span>
      </ContainerTop>
      <ContainerBody>
        {loading ? (
          <IonSpinner name="lines" />
        ) : index === -1 ? (
          <SubirEditarOrden
            imageMod={imageMod}
            turno={turno}
            dissmiss={dissmiss}
          />
        ) : (
          <>
          <ConfirmImage
            image={`data:image/png;base64,${image[index]?.binario}`}
            setIndex={setIndex}
            imageMod={imageMod}
            setImageMod={setImageMod}
            index={index}
            listImagenes={image}
            idProtocolo={turno?.idProtocolo}
            idturno={turno?.idturno}
            dissmiss={dissmiss}
            listImage={image}
          />
        <div className="container-btn">
          <button
            onClick={fail}
            className="btn btn-validaturno bgc-danger c-white rb14m"
          >
            NO
          </button>
          <button
            onClick={success}
            className="btn btn-validaturno bgc-broccoli c-white rb14m"
          >
            SI
          </button>
        </div>
          
          </>
        )}
      </ContainerBody>
    </ContainerEditarOrden>
  );
};

export default EditarOrden;

// wsDeleteOrdenEstudio(turno.idturno, imgID)(ordenEstudioDispatch);
